
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.22 21.463a1.36 1.36 0 01-.194-.463h1.948c-.038.167-.1.326-.194.463-.123.18-.34.384-.78.51-.44-.126-.657-.33-.78-.51zM13.165 21s0 0 0 0h0zm-2.332 0h0s0 0 0 0z","stroke":"#000","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 7.165c.75-2.249 3.186-4.78 4.358-5.905a.921.921 0 011.284 0C13.814 2.386 16.25 4.916 17 7.165c.383 1.148.345 2.804.124 4.503A3 3 0 0120 14.666v4.131a1 1 0 01-1.555.832l-2.92-1.947a2.905 2.905 0 01-2.195.984h-2.668c-.86 0-1.657-.367-2.192-.98l-2.915 1.943A1 1 0 014 18.797v-4.132a3 3 0 012.866-2.997C6.648 9.977 6.614 8.324 7 7.165zm5 3.5a2 2 0 100-4 2 2 0 000 4z"}})])
          )
        }
      }
    